import { WindowState } from '../state';

export function createDimensionInputs(state: WindowState): HTMLElement {
  const container = document.createElement('div');

  // Width
  const widthRow = createSliderRow('Width', 300, 3000, state.config.width, 'mm', (v) => {
    state.setDimensions(v, state.config.height);
  });
  container.appendChild(widthRow);

  // Height
  const heightRow = createSliderRow('Height', 300, 3000, state.config.height, 'mm', (v) => {
    state.setDimensions(state.config.width, v);
  });
  container.appendChild(heightRow);

  return container;
}

function createSliderRow(
  label: string,
  min: number,
  max: number,
  value: number,
  unit: string,
  onChange: (v: number) => void,
): HTMLElement {
  const row = document.createElement('div');
  row.className = 'opt-row';

  const lbl = document.createElement('span');
  lbl.className = 'opt-label';
  lbl.textContent = label;

  const slider = document.createElement('input');
  slider.type = 'range';
  slider.className = 'opt-range';
  slider.min = String(min);
  slider.max = String(max);
  slider.step = '10';
  slider.value = String(value);

  const display = document.createElement('span');
  display.className = 'opt-value';
  display.textContent = `${value}${unit}`;

  slider.addEventListener('input', () => {
    const v = parseInt(slider.value, 10);
    display.textContent = `${v}${unit}`;
    onChange(v);
  });

  row.appendChild(lbl);
  row.appendChild(slider);
  row.appendChild(display);
  return row;
}
